import * as React from 'react';
import TrackVisibility from 'react-on-screen';
import PageInfo from '../../../common/PageInfo/PageInfo';
import Carousel from '../../../common/Carousel/Carousel';

import classifiedsImg from '../../../../images/classifieds.svg';
import journalistsImg from '../../../../images/journalists.svg';
import agenciesImg from '../../../../images/agencies.svg';

import * as styles from './Cooperate.module.scss';

const CooperateSlides = [
  {
    title1: 'Classi-',
    title2: 'fieds',
    subtitle1: 'We work with',
    description: 'We invite real estate classifieds websites to participate in our partnership program. Increase your revenue with Flatfy traffic-boosting solution.',
    img: classifiedsImg
  },
  {
    title1: 'agencies',
    subtitle1: 'We work with',
    description: 'Flatfy.com gets 10 mln yearly visits from people who want to rent a home. All of them are your potential customers. Don’t miss out on an opportunity to speak directly with your target audience.',
    img: agenciesImg
  },
  {
    title1: 'JOURNA-',
    title2: 'LISTS',
    subtitle1: 'We work with',
    description: 'Get in touch and get access to the latest real estate analysis. Spice up your reporting with fresh real estate data.',
    img: journalistsImg
  }
];

const Cooperate = () => (
  <section className={styles.root}>
    <TrackVisibility partialVisibility={true} style={{height: '100%'}}>
      {({ isVisible }) =>
        <div className={styles.containerWrapper}>
          <Carousel slides={CooperateSlides} color='white' smallImg={true} isVisible={isVisible} page='cooperate'/>
          <PageInfo text={"06 - let's cooperate"}/>
        </div>
      }
    </TrackVisibility>
  </section>
);

export default Cooperate;
